// Green design
const GreenDesign = {
  id: 'green',
  name: 'Green',
  category: 'tech',
  description: 'Modern creative design with green accents',
  colors: {
    primary: "#1DB954",    // Green
    secondary: "#191414",  // Black
    tertiary: "#1ED760",   // Bright Green
    quaternary: "#535353", // Dark Gray
    accent1: "#CDF564",    // Lime
    accent2: "#509BF5",    // Light Blue
    accent3: "#4687FB",    // Blue
    accent4: "#2D46B9",    // Dark Blue
    accent5: "#AF2896",    // Purple
    accent6: "#F037A5",    // Pink
    accent7: "#B3B3B3",    // Light Gray
    accent8: "#FFFFFF",    // White
    text: "#191414",       // Black Text
    textSecondary: "#535353", // Secondary Text
    background: "#FFFFFF", // White background
    sidebarBackground: "#F8F8F8", // Light gray background
    border: "#EBEBEB",     // border color
  },
};

export default GreenDesign; 